import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';


//import { ModalContentPage } from '../pages//modalcontent';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import {MydataService} from '../home/mydata.service';
import {MyUrlService} from '../home/checkUrll';
import {MyvariableService} from '../home/constantvariable';
import {HomePage} from "../home/home";
import {AppHomePage} from "../apphome/apphome";
import {OtpPage} from "../otp/otp";
import { Observable }        from 'rxjs/Observable';
import {JsonData} from '../home/dataaa';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';

//import  { Http } from '@angular/http';
@Component({
	selector: 'page-signup',
	templateUrl: 'signup.html',
	providers:[MydataService,MyUrlService,JsonData,MyvariableService]
})

export class SignUpPage {
	
	jsonDt : Array<JsonData>;
	
	private todo : FormGroup;
		selectGender:string;
	private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home' ];
	
	
	constructor(public modalCtrl: NavController,public loading: LoadingController,public alerCtrl: AlertController,private formBuilder: FormBuilder,private mydataService: MydataService, private myurlService: MyUrlService,private MyvariableService: MyvariableService) {
		this.todo = this.formBuilder.group({
			name: ['',Validators.required],
			mobileno: ['', Validators.required],
			emailid: ['', [ Validators.pattern('[a-z0-9._%+-]+@[a-z]+\\.+[a-z.]+')]],
			city: ['', Validators.required],
		});
		
	}
	
	logForm(name,mobileno,emailid,city){
		var checkEmpty = '';
		
		if(name.match(/[!$%^&*()+|~=`{}\[\]:";#@'<>?,.\/\\0-9]/g))
		{
			this.showAlertname();
		}else if(mobileno.match(/[!$%^&*()+|~=`{}\[\]:";#@'<>?,.\/\\a-zA-Z\s ]/g))
		{
			this.showAlertmobileno();
		}else if(city.match(/[!$%^&*()+|~=`{}\[\]:";#@'<>?,.\/\\0-9]/g))
		{
			this.showAlertcity();
		} else if(emailid==checkEmpty)
		{
			this.serviceCall(name,mobileno,emailid,city);
			}else{
			if(emailid.match('[a-z0-9]+@[a-z0-9]+.[a-z]+')){
				this.serviceCall(name,mobileno,emailid,city);	
			}
		}
	}
	
	errorFunction= function(loader,error){
		loader.dismiss();
		////console.log(error);
		//alert(error);
	}
	
serviceCall=function(name,mobileno,emailid,city){
		////console.log(this.todo.value);
		if(this.selectGender==null){
		this.selectGender='';
		}
		if(this.mydataService.checkInternetFunction()=="0"){
			//////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var kiloSabjiJSONdata = JSON.stringify({"name":name,"mobileno":mobileno,"emailid":emailid,"city":city,"gender":this.selectGender});
			////console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.SIGNUPURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.SIGNUPURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.signUpService(loader));
			});
		}
	}
	
	
	signUpService=function(loader){
		//////console.log("jsondata ==>"+JSON.stringify(this.jsonDt.sinupdata));
		this.todo = this.formBuilder.group({
			name: ['', Validators.required],
			mobileno: ['', Validators.required],
			emailid: ['', ''],
			city: ['', Validators.required],
		});
		
		let uid = this.jsonDt.sinupdata;
		let msg = this.jsonDt.msg;
		this.REGISTEREDMSG= this.MyvariableService.REGISTEREDMSG;
		// alert(uid);
		loader.dismiss();
		if(uid!=''){
			window.localStorage.setItem('phoneno',  msg);
			window.localStorage.setItem('sinupid',  uid);
			var xyz = window.localStorage.getItem('sinupid');
			//alert(JSON.stringify(msg));
			this.modalCtrl.push(OtpPage);
			}else{
			//alert(msg);
			this.showAlert();
		}
		
		//////console.log("categorydata ==>"+JSON.stringify(this.jsonDt.categorydata));
		//////console.log("namedata ==>"+JSON.stringify(this.jsonDt.namedata));
		//////console.log("mobilenodata ==>"+JSON.stringify(this.jsonDt.mobilenodata));
		//	////console.log("func post ---->"+this.postData);
		
	}
	
	
	selectionGender(selecItem){
			 //alert("work--->"+selecItem);
			this.selectGender = selecItem;
			//window.localStorage.setItem('gender',this.selectItem);
			//var Gender=window.localStorage.getItem('gender');
			//alert('ccccccccccccccc'+Gender);
			
			
	}
	
	_keyPress(event: any) {
		const pattern = /[0-9\ ]/;
		let inputChar = String.fromCharCode(event.charCode);
		
		if (!pattern.test(inputChar)) {
			
			if(this.specialKeys.indexOf(event.key) !== -1)
			{
				return;
				// invalid character, prevent input
				
			}
			//alert('Enter The Number');
			event.preventDefault();
		}
	}
	
	
	
	
	itemSelected()
	{
		this.modalCtrl.push(HomePage);
	}
	apphome()
	{
		this.modalCtrl.push(AppHomePage);
	}
	showAlert=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.REGISTEREDMSG,
			buttons: ['OK']
		});
		alert.present();
	}
	showAlertname=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter correct name',
			buttons: ['OK']
		});
		alert.present();
	}
	showAlertmobileno=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter valid mobile no',
			buttons: ['OK']
		});
		alert.present();
	}
	showAlertcity=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter correct city name',
			buttons: ['OK']
		});
		alert.present();
	}
	
}





// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts